import Popup from 'react-popup';

Popup.registerPlugin('confirmAction', function plugin(actionText, onConfirmState) {
  this.create({
    title: null,
    content: `Você confirma esta ação?\n${actionText}`,
    buttons: {
      left: [{
        text: 'Cancelar',
        key: 'esc',
        action: () => {
          onConfirmState(false);
          this.close();
        },
      }],
      right: [{
        text: 'Confirmar',
        className: 'danger',
        action: () => {
          onConfirmState(true);
          this.close();
        },
      }],
    },
  });
});


export default {
  show(actionText = '') {
    return new Promise(resolve => Popup.plugins().confirmAction(actionText, resolve));
  },
};



// WEBPACK FOOTER //
// ./src/Shared/Popup/Confirmation.js